import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalComponent } from "../../../global-component";
import{GenericGetData} from "../../../core/models/get-data.model";
import{Cliente} from"../models/cliente.model";
import {SaveCliente} from '../models/request/save-cliente.model';
import {EditCliente} from '../models/request/edit-cliente.model';
import { SelectOptionResponse } from 'src/app/shared/models/generic-entities.model';
@Injectable({
  providedIn: 'root'
})
export class ClienteService {

  private urlService = 'configuraciones/cliente/';
  constructor(private http: HttpClient) {}

  getAll(page: number, pageSize: number, filter: string) {
    let urlFilter = page === 0 || pageSize === 0 ? "" : `?pageNumber=${page}&pageSize=${pageSize}&filter=${filter}`;
    return this.http.get<GenericGetData<Cliente[]>>(`${GlobalComponent.API_URL}${this.urlService}${"getall"}${urlFilter}`, { reportProgress: true, observe: "events" });
  }

  getSelectOption() {
    return this.http.get<SelectOptionResponse[]>(`${GlobalComponent.API_URL}${this.urlService}${"select"}`, { reportProgress: true, observe: "events" });
  }

  getId(page: number, pageSize: number, filter: string) {
    let urlFilter = page === 0 || pageSize === 0 ? "" : `?filter=${filter}`;
    return this.http.get<GenericGetData<Cliente[]>>(`${GlobalComponent.API_URL}${this.urlService}${"getId"}${urlFilter}`, { reportProgress: true, observe: "events" });
  }

  save(data: SaveCliente) {
    //return this.http.post<GenericGetData<Cuadrilla[]>>(`${GlobalComponent.API_URL}${this.urlService}${"save"}`,data, { reportProgress: true, observe: "events" });
    return this.http.post(`${GlobalComponent.API_URL}${this.urlService}${"save"}`,data);
  }

  edit(data: EditCliente) {
    //return this.http.post<GenericGetData<Cuadrilla[]>>(`${GlobalComponent.API_URL}${this.urlService}${"save"}`,data, { reportProgress: true, observe: "events" });
    return this.http.post(`${GlobalComponent.API_URL}${this.urlService}${"edit"}`,data);
  }
}
